import { useContentful } from './useContentful';
import { useQuery } from '@tanstack/react-query';

export const useStihlIdNavigation = (enabled = false, locale?: string) => {
  const { getStihlIdMenuNavItems } = useContentful();

  const stihlIdNavigationItemsQuery = useQuery(['STIHL_NAV', 'STIHL_ID_MENU'], () => getStihlIdMenuNavItems(locale), {
    enabled: Boolean(locale && enabled),
  });

  return {
    stihlIdNavigationItemsQuery,
  };
};
